module.exports = new __parcel__URL__("lune-pluie-3.daa267b6.svg").toString();